import { render } from "./SliderTypeComponent.vue?vue&type=template&id=5ae9f3aa&scoped=true"
import script from "./SliderTypeComponent.vue?vue&type=script&lang=js"
export * from "./SliderTypeComponent.vue?vue&type=script&lang=js"

import "./SliderTypeComponent.vue?vue&type=style&index=0&id=5ae9f3aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae9f3aa"]])

export default __exports__